import { resolveApiErrorMessage } from './api-error-message';
import { NotifyFailure } from './notify-failure';

export async function fetchResponseHandler({ response }) {
  // fetchApi calls this from a finally block, so anything thrown here escapes as an unhandled
  // TypeError rather than a toast. A dropped connection leaves `response` undefined.
  if (!response) {
    NotifyFailure({ message: resolveApiErrorMessage({}) });
    return { responseBody: undefined, responseStatus: 0 };
  }

  let responseBody;
  try {
    const contentType = response.headers.get('content-type');
    // Matched on "json", not "application/json": ASP.NET answers client errors with
    // application/problem+json, which the narrower test missed — so error bodies were read as text
    // and the raw ProblemDetails payload went straight into a toast. WK-204.
    responseBody =
      contentType && contentType.includes('json')
        ? await response.json()
        : await response.text();
  } catch (error) {
    console.error('Error reading response body:', error);
  }

  if (response.status >= 400) {
    NotifyFailure({ message: resolveApiErrorMessage({ status: response.status, body: responseBody }) });
    console.error(`Fetch response error (${response.status}): ${JSON.stringify(responseBody)}`);
  }

  return { responseBody, responseStatus: response.status };
}
